var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.checkAnchorKinds)?_c('section',[_c('div',{staticClass:"folder"},[_c('h2',{staticClass:"folder__title"},[_vm._v(_vm._s(_vm.capitalizeName))]),_vm._l((_vm.parseData),function(item,index){return [(
          (Array.isArray(item.roles) && item.roles.includes(_vm.currentRole)) ||
          _vm.currentRole === 'All Roles'
        )?_c('Method',{key:index,attrs:{"method":item}}):_vm._e()]})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }